<template>
    <el-dialog title="单位" width="70%" :visible="dialogVisible" :show-close="false" :destroy-on-close="true">
      <el-form :model="unitInfo" ref="unitForm" :rules="rules" size="small">
        <el-row>
            <el-col :span="24">
             <el-form-item label="单位名称" :inline="true" prop="unitName">
              <el-input v-model="unitInfo.unitName" placeholder="请输入单位名称" autocomplete="off"></el-input>
            </el-form-item>
            </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="编码" :inline="true" prop="unitCode">
              <el-input v-model="unitInfo.unitCode" :disabled="unitInfo.uneditUnitCode" placeholder="请输入编码" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="纳税识别号" :inline="true" prop="nsrsbh">
              <el-input v-model="unitInfo.nsrsbh" :disabled="unitInfo.uneditNsrsbh" placeholder="请输入纳税识别号" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="状态" :inline="true" prop="status">
                  <el-select v-model="unitInfo.status" placeholder="请选择状态" style="width:100%">
                    <el-option label="正常" value="0"></el-option>
                    <el-option label="停用" value="1"></el-option>
                  </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="是否强制验真" :inline="true" prop="mustVerify">
                  <el-select v-model="unitInfo.mustVerify" placeholder="请选择是否强制验真" style="width:100%">
                    <el-option label="否" :value="0"></el-option>
                    <el-option label="是" :value="1"></el-option>
                  </el-select>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="办税小号"  :inline="true" prop="qxyBsxh">
                  <el-input v-model="unitInfo.qxyBsxh" width="90%" placeholder="请输入办税小号" autocomplete="off"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="办税密码" :inline="true" prop="qxyLoginPassword">
                  <el-input v-model="unitInfo.qxyLoginPassword" placeholder="请输入办税密码" show-password autocomplete="off"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="地区" :inline="true" prop="qxyDq">
                     <el-select v-model="unitInfo.qxyDq" placeholder="请选择地区" filterable style="width:100%">
                       <el-option label="北京市" :value="11"></el-option>
                       <el-option label="天津市" :value="12"></el-option>
                       <el-option label="河北省" :value="13"></el-option>
                       <el-option label="山西省" :value="14"></el-option>
                       <el-option label="内蒙古" :value="15"></el-option>
                       <el-option label="辽宁省" :value="21"></el-option>
                       <el-option label="大连市" :value="2102"></el-option>
                       <el-option label="吉林省" :value="22"></el-option>
                       <el-option label="黑龙江省" :value="23"></el-option>
                       <el-option label="上海市" :value="31"></el-option>
                       <el-option label="江苏省" :value="32"></el-option>
                       <el-option label="浙江省" :value="33"></el-option>
                       <el-option label="宁波市" :value="3302"></el-option>
                       <el-option label="安徽省" :value="34"></el-option>
                       <el-option label="福建省" :value="35"></el-option>
                       <el-option label="厦门市" :value="3502"></el-option>
                       <el-option label="江西省" :value="36"></el-option>
                       <el-option label="山东省" :value="37"></el-option>
                       <el-option label="青岛市" :value="3702"></el-option>
                       <el-option label="河南省" :value="41"></el-option>
                       <el-option label="湖北省" :value="42"></el-option>
                       <el-option label="湖南省" :value="43"></el-option>
                       <el-option label="广东省" :value="44"></el-option>
                       <el-option label="深圳市" :value="4403"></el-option>
                       <el-option label="广西" :value="45"></el-option>
                       <el-option label="海南省" :value="46"></el-option>
                       <el-option label="重庆市" :value="50"></el-option>
                       <el-option label="四川省" :value="51"></el-option>
                       <el-option label="贵州省" :value="52"></el-option>
                       <el-option label="云南省" :value="53"></el-option>
                       <el-option label="西藏" :value="54"></el-option>
                       <el-option label="陕西省" :value="61"></el-option>
                       <el-option label="甘肃省" :value="62"></el-option>
                       <el-option label="青海省" :value="63"></el-option>
                       <el-option label="宁夏" :value="64"></el-option>
                       <el-option label="新疆" :value="65"></el-option>
                     </el-select>
               </el-form-item>
           </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeUnit()">取 消</el-button>
        <el-button size="small" @click="saveUnitInfo()" type="primary">确 定</el-button>
      </div>
    </el-dialog>    
</template>

<script>
import { Message,MessageBox } from 'element-ui';
import { saveUnit,listUnit,deleteById } from "@/api/unit";

export default {
  name: "EditUnitDialog",
  props: {
    dialogVisible: false,
    unitInfo: {
        id : '',
        unitCode:'',
        unitName:'',
        nsrsbh:'',
        showClose: false,
        uneditUnitCode:false,
        uneditNsrsbh:false,
        qxyBsxh:'',
        qxyLoginPassword:'',
        qxyDq:'',
        mustVerify:1
    },
  },
  data(){
    return {
      rules: {
          unitCode: [
            { required: true, message: "请输入单位编码", trigger: "blur" },
          ],
          unitName: [
            { required: true, message: "请输入单位名称", trigger: "blur" },
          ],
          nsrsbh: [
            { required: true, message: "请输入纳税识别号", trigger: "blur" },
          ],
          status: [
            { required: true, message: "请选择状态", trigger: "blur" },
          ],
          mustVerify: [
            { required: true, message: "请选择是否强制验真", trigger: "blur" },
          ]
      },
      loading:false,
    }
  },
  mounted(){
    
  },
  created() {
     
  },
  watch : {
    
  },
  methods: {
    
    //打开新增用户弹窗
    closeUnit(){
      this.$emit('closeUnitDialog');
    },

    //保存标签
    saveUnitInfo(){
      var _this = this;
      this.$refs.unitForm.validate((valid) => {
          if(valid){
             let param = _this.unitInfo;
             saveUnit(param).then(res => {
                if(res.code == 200){
                    Message.success('保存成功');
                    _this.$emit('closeUnitDialog');
                } else {
                   Message.error(res.msg);
                }
             }); 
          }
      });
    },
  
    
  },
};
</script>



// WEBPACK FOOTER //
// src/views/components/dialog/EditUnitDialog.vue